let timeout
let urlsToCheck = []

const streamURL = () => document.querySelector('meta[name="stream"]')?.content

const checkStream = function(player, index) {
  if (index >= urlsToCheck.length) {
    index = 0
  }
  const url = urlsToCheck[index]
  if (!url) return

  timeout = setTimeout(() => checkStream(player, index + 1), 10000)

  fetch(url)
    .then(response => {
      if (response.ok) {
        return response.text()
      }
    })
    .then(text => {
      if (!text) return

      if (text.includes("https:")) {
        urlsToCheck = [...text.matchAll(/https:.+?\.m3u8/g).map(a => a[0])]
        clearTimeout(timeout)
        checkStream(player, 0)
      } else {
        clearTimeout(timeout)
        let loadStream = () => player.load([{ file: streamURL() }]).play()

        if (player.getState()) {
          loadStream()
        } else {
          player.on("ready", loadStream)
        }
      }
    })
}

document.addEventListener("DOMContentLoaded", function() {
  const settingsMeta = document.querySelector('meta[name="settings"]')
  if (!settingsMeta) return

  const settings = JSON.parse(settingsMeta.content)
  const player = jwplayer("player").setup(settings)

  player.on("ready", function() {
    player.setConfig(settings)
  })

  const url = streamURL()
  if (url) {
    urlsToCheck = [url]
    checkStream(player, 0)
  }
})
